/**
 * Tag colours: ten ready ones (the suggestions of the setup journey use them) and any other the
 * person picks. Tag chips darken or lighten the text on their own, so a light colour stays legible.
 */
export const TAG_COLORS = [
  { key: "blue", hex: "#2563eb" },
  { key: "green", hex: "#0f766e" },
  { key: "yellow", hex: "#ca8a04" },
  { key: "red", hex: "#b91c1c" },
  { key: "purple", hex: "#7c3aed" },
  { key: "light_gray", hex: "#94a3b8" },
  { key: "brown", hex: "#92400e" },
  { key: "orange", hex: "#c2410c" },
  { key: "dark_gray", hex: "#475569" },
  { key: "pink", hex: "#db2777" },
] as const;

export type TagColorKey = (typeof TAG_COLORS)[number]["key"];

export const DEFAULT_TAG_COLOR: string = TAG_COLORS[0].hex;

export function sameColor(
  a: string | null | undefined,
  b: string | null | undefined,
): boolean {
  return !!a && !!b && a.trim().toLowerCase() === b.trim().toLowerCase();
}

/** Relative luminance of a #rrggbb colour (WCAG), 0 for anything else. */
export function luminance(hex: string): number {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return 0;
  const n = parseInt(m[1]!, 16);
  const channel = (v: number) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  return (
    0.2126 * channel((n >> 16) & 255) +
    0.7152 * channel((n >> 8) & 255) +
    0.0722 * channel(n & 255)
  );
}

const DARK_INK = "#1b1d1d";

/** Ink for a mark drawn on the colour itself (the check on a swatch): whichever contrasts more. */
export function inkOn(hex: string): string {
  const l = luminance(hex);
  const onWhite = 1.05 / (l + 0.05);
  const onDark = (l + 0.05) / (luminance(DARK_INK) + 0.05);
  return onDark > onWhite ? DARK_INK : "#ffffff";
}
